import { __read, __awaiter, __generator } from 'tslib';
import * as React from 'react';
import { CartContext } from '../../../../context/CartContext.esm.js';
import '../../../../context/CartSettingsContext.esm.js';
import 'lodash/isEqual';
import 'markdown-to-jsx';
import '@invitae/ids-react';
import 'lodash/isEmpty';
import '@invitae/analytics-queue';
import { isRnaAnalysisTestSelection, getReflexOptionsWithGroupedAddOns } from '../../OrderCard.utils.esm.js';
import '../../../../constants/analytics.esm.js';
import '../../../../modals/content/index.esm.js';
import '../../../../modals/content/default_validation_error.esm.js';
import '../../../../modals/ModalBuilder.models.esm.js';
import 'squirrelly';
import '../../../../modals/postProcessingActions/processLocationValidationError.esm.js';
import '@invitae/stargate-ts-fetch';
import 'classnames';
import '../../../../constants/api.esm.js';
import partition from 'lodash/partition';
import ReflexTest from '../../ReflexTest/ReflexTest.esm.js';
import RnaAnalysisContainer from '../../RnaAnalysisContainer/RnaAnalysisContainer.esm.js';
import Select from '../../../Select/index.esm.js';
import reflexTestSelectionStyles from './ReflexTestSelection.module.esm.js';

var ReflexTestSelection = function (_a) {
    var orderGroup = _a.orderGroup;
    var _b = React.useContext(CartContext), addReflexTests = _b.addReflexTests, clearReflexCustomizedSelection = _b.clearReflexCustomizedSelection, _c = _b.featureFlags, _d = _c === void 0 ? {} : _c, _e = _d.cx_custom_rna_hcx, isCxCustomRnaHcxEnabled = _e === void 0 ? false : _e, removeReflexTests = _b.removeReflexTests, searchReflexTests = _b.searchReflexTests;
    var _f = orderGroup.meta, allReflexTestSelections = _f.reflex.richReflexTests, _g = _f.rna, _h = _g === void 0 ? {} : _g, isReflexRnaAnalysisAvailable = _h.isReflexRnaAnalysisAvailable, isReflexRnaAnalysisSelected = _h.isReflexRnaAnalysisSelected, rereqSetCode = orderGroup.rereqSetCode;
    var _j = __read(partition(allReflexTestSelections, function (testSelection) { return !isRnaAnalysisTestSelection(testSelection.name); }), 2), reflexTestSelections = _j[0], reflexRnaAnalysisTestSelections = _j[1];
    var loadOptions = React.useCallback(function (query) {
        return searchReflexTests(rereqSetCode, query);
    }, [rereqSetCode, searchReflexTests]);
    var handleTestSelection = React.useCallback(function (option) {
        // in case the option was cleared, the onChange is still called
        if (!option)
            return;
        var tests = option.isCustomPanel ? option.geneCodes : [option.value];
        addReflexTests(rereqSetCode, tests);
    }, [addReflexTests, rereqSetCode]);
    var handleTestRemoval = React.useCallback(function (_a) {
        var isCustom = _a.isCustom, code = _a.code;
        isCustom ? clearReflexCustomizedSelection(rereqSetCode) : removeReflexTests(rereqSetCode, [code]);
    }, [clearReflexCustomizedSelection, rereqSetCode, removeReflexTests]);
    var loadReflexOptions = React.useCallback(function (query) { return __awaiter(void 0, void 0, void 0, function () {
        var options;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, loadOptions(query)];
                case 1:
                    options = (_a.sent()) || [];
                    return [2 /*return*/, getReflexOptionsWithGroupedAddOns(options)];
            }
        });
    }); }, [loadOptions]);
    return (React.createElement("div", { className: reflexTestSelectionStyles.root, "data-testid": "reflex-test-selection" },
        React.createElement("div", { className: reflexTestSelectionStyles.dropdownWrapper },
            React.createElement(Select, { loadOptions: loadReflexOptions, onChange: handleTestSelection, placeholder: "Add a test", uniqueKey: JSON.stringify(orderGroup) })),
        React.createElement("div", { className: reflexTestSelectionStyles.reflexTestsWrapper }, reflexTestSelections === null || reflexTestSelections === void 0 ? void 0 :
            reflexTestSelections.map(function (test) {
                var _a;
                return (React.createElement("div", { className: reflexTestSelectionStyles.reflexTest, "data-testid": "reflex-test-item", key: test.code },
                    React.createElement(ReflexTest, { removeReflexTest: handleTestRemoval, test: test }), (_a = test === null || test === void 0 ? void 0 : test.addOns) === null || _a === void 0 ? void 0 :
                    _a.map(function (addOn) { return (React.createElement(ReflexTest, { isAddon: true, key: addOn.code, removeReflexTest: handleTestRemoval, test: addOn })); })));
            }),
            isCxCustomRnaHcxEnabled && isReflexRnaAnalysisAvailable && (React.createElement(RnaAnalysisContainer, { isReflex: true, isRnaAnalysisSelected: isReflexRnaAnalysisSelected, rereqSetCode: rereqSetCode, rnaAnalysisTestSelection: reflexRnaAnalysisTestSelections[0] })))));
};

export { ReflexTestSelection as default };
//# sourceMappingURL=ReflexTestSelection.esm.js.map
